import {
  Alert,
  Button,
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Text,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useFormikContext } from "formik";
import { DisplayFormErrors, DrawerFooterContent } from "melco-shared-logic";
import { CreateLicenseFormValueType } from "./CreateLicenseForm";
import { Descriptions } from "antd";
import dayjs from "dayjs";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type DisplayCreateLicenseSummaryProps = {
  licenseFormValues?: CreateLicenseFormValueType;
  licenseDisplayValues: any;
  stepback: () => void;
  disableCreateAndSendEmailButton: boolean;
};

const { spacings } = DesignTokens;

const StyledDescriptionsDiv = styled.div`
  margin-top: 15px;
`;

// const Label = styled(Text)`
//   display: block;
//   font-family: ${fonts.sansSerifMd};
// `;

export const DisplayCreateLicenseSummary: React.FC<
  DisplayCreateLicenseSummaryProps
> = ({
  stepback,
  licenseFormValues,
  licenseDisplayValues,
  disableCreateAndSendEmailButton,
}) => {
    const { t } = useTranslation();
    const { submitForm } = useFormikContext();

    return (
      <>
        <FullWidthSpace direction="vertical" size="small">
          <DisplayFormErrors />
          <Title level={4}> {t("licensemanager.create.form.summary")}</Title>
          <Alert
            type="info"
            closable={false}
            message={t("licensemanager.create.alert.message")}
          />
          <Row gutter={[spacings.middle, 0]}>
            <Col xs={24} md={6}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("licensemanager.create.form.melco_customer_id")}
                  content={licenseFormValues?.melco_customer_id ?? ""}
                  fallback={t("global.fallback.empty")}
                />
                <LabeledItem
                  label={t("licensemanager.create.form.product")}
                  content={licenseDisplayValues?.product_code_label ?? ""}
                  fallback={t("global.fallback.empty")}
                />

                <LabeledItem
                  label={t("licensemanager.create.form.version")}
                  content={licenseDisplayValues?.version_number_label ?? ""}
                  fallback={t("global.fallback.empty")}
                />

                <LabeledItem
                  label={t("licensemanager.create.form.level")}
                  content={licenseDisplayValues?.subscription_code_label ?? ""}
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
            {licenseDisplayValues?.productIsSubscription && (
              <Col xs={24} md={8}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licensemanager.create.form.subscription_start_date")}
                    content={dayjs(
                      licenseDisplayValues?.subscription_start_date ?? ""
                    ).format("MM/DD/YYYY")}
                    fallback={t("global.fallback.empty")}
                  />
                  <LabeledItem
                    label={t("licensemanager.create.form.affiliate_name")}
                    content={licenseDisplayValues?.affiliate_name ?? ""}
                    fallback={t("global.fallback.empty")}
                  />
                </Space>
              </Col>
            )}
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("licensemanager.create.form.email")}
                  content={licenseFormValues?.email_address ?? ""}
                  fallback={t("global.fallback.empty")}
                />

                <LabeledItem
                  label={t("licensemanager.create.form.dont_assign_license")}
                  content={
                    licenseFormValues?.assign_license
                      ? t("common.yes")
                      : t("common.no")
                  }
                  fallback={t("global.fallback.empty")}
                />

                <LabeledItem
                  label={t("licensemanager.create.form.language")}
                  content={licenseDisplayValues?.language}
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
          </Row>
          {licenseDisplayValues?.productIsSubscription && (
            <StyledDescriptionsDiv>
              <Title level={4}>{t("licensemanager.create.license_cost")}</Title>
              <Descriptions bordered column={1}>
                <Descriptions.Item
                  label={<Text>{t("licensemanager.create.form.subscription_start_date")}</Text>}
                  labelStyle={{ width: "40%", backgroundColor: "#ffffff" }}
                >
                  {" "}
                  <Text>
                    {dayjs(licenseDisplayValues?.subscription_start_date).format(
                      "MM/DD/YYYY"
                    )}
                  </Text>
                </Descriptions.Item>
                <Descriptions.Item
                  label={t("licensemanager.create.total_cost")}
                  labelStyle={{ width: "40%", backgroundColor: "#ffffff" }}
                //contentStyle={{ backgroundColor: "#fafafa" }}
                >


                  {"$" + (licenseDisplayValues?.subscription_cost ?? 0)}
                  {" / "} {licenseDisplayValues?.subscription_code_label}

                </Descriptions.Item>
              </Descriptions>
            </StyledDescriptionsDiv>
          )}{" "}
        </FullWidthSpace>
        <DrawerFooterContent>
          <Row>
            <Col xs={24} md={12}>
              <Button
                style={{ minWidth: "80px" }}
                key={"back-btn"}
                type="primary"
                onClick={stepback}
              >
                {t("licensemanager.buttons.back")}
              </Button>
            </Col>
            <Col
              style={{ display: "flex", justifyContent: "flex-end" }}
              xs={24}
              md={12}
            >
              <Right>
                <Button
                  style={{ minWidth: "80px" }}
                  key="add-user-button"
                  type="primary"
                  onClick={() => submitForm()}
                  disabled={disableCreateAndSendEmailButton}
                >
                  {t("licensemanager.buttons.createsendemail")}
                </Button>
              </Right>
            </Col>
          </Row>
        </DrawerFooterContent>
      </>
    );
  };
